module.exports = __webpack_public_path__ + "fonts/LatoLatin-Regular.ddabf82.woff";